var _text, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollDownEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.495,
    height: 36.496,
    viewBox: "0 0 151.495 36.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(34.495 32.496)",
    fill: "#8a909f",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "More information"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.995 26) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.712,7.69,1.678,13.708a.981.981,0,0,1-1.39-1.386L5.627,7,.288,1.673A.981.981,0,0,1,1.678.287L7.712,6.3a.978.978,0,0,1,0,1.386Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.995 13) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.712,7.69,1.678,13.708a.981.981,0,0,1-1.39-1.386L5.627,7,.288,1.673A.981.981,0,0,1,1.678.287L7.712,6.3a.978.978,0,0,1,0,1.386Z",
    fill: "#fff",
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.995 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.712,7.69,1.678,13.708a.981.981,0,0,1-1.39-1.386L5.627,7,.288,1.673A.981.981,0,0,1,1.678.287L7.712,6.3a.978.978,0,0,1,0,1.386Z",
    fill: "#fff",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDownEn);
export default __webpack_public_path__ + "static/media/scroll_down_en.48a68c3cdbae74c5f8782736210edf50.svg";
export { ForwardRef as ReactComponent };